import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { FaEye, FaEyeSlash, FaExclamationCircle } from 'react-icons/fa';
import '../LoginPage/Form.css';

const RegisterPage = () => {
    const [formData, setFormData] = useState({ name: '', username: '', password: '', address: '', phone_number: '' });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        if (errors[e.target.name] || errors.general) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[e.target.name];
                delete newErrors.general;
                return newErrors;
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});
        setIsLoading(true);

        try {
            await api.post('/auth/register-customer', formData);
            toast.success('Registrasi berhasil! Silakan login.');
            navigate('/login');
        } catch (error) {
            if (error.response && error.response.status === 400 && error.response.data.errors) {
                const backendErrors = {};
                error.response.data.errors.forEach(err => {
                    backendErrors[err.path] = err.msg;
                });
                setErrors(backendErrors);
                toast.error("Gagal mendaftar. Mohon periksa kembali data Anda.");
            } else {
                const errorMessage = error.response?.data?.message || 'Terjadi kesalahan. Coba lagi nanti.';
                setErrors({ general: errorMessage });
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="form-container">
            <form onSubmit={handleSubmit} className="auth-form">
                <h2>Buat Akun Baru</h2>
                {/* Teks subtitle dipindahkan dari sini */}

                {errors.general && (
                    <div className="error-message-general">
                        <FaExclamationCircle />
                        <span>{errors.general}</span>
                    </div>
                )}

                <div className="form-group">
                    <label htmlFor="name">Nama Lengkap</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} required className={errors.name ? 'input-error' : ''} />
                    {errors.name && <div className="error-text"><FaExclamationCircle /><span>{errors.name}</span></div>}
                </div>
                <div className="form-group">
                    <label htmlFor="username">Username</label>
                    <input type="text" name="username" value={formData.username} onChange={handleChange} required className={errors.username ? 'input-error' : ''} />
                    {errors.username && <div className="error-text"><FaExclamationCircle /><span>{errors.username}</span></div>}
                </div>
                <div className="form-group password-group">
                    <label htmlFor="password">Password</label>
                    <div className="password-input-wrapper">
                        <input type={showPassword ? 'text' : 'password'} name="password" value={formData.password} onChange={handleChange} required className={errors.password ? 'input-error' : ''} />
                        <span className="password-toggle-icon" onClick={() => setShowPassword(!showPassword)}>{showPassword ? <FaEye /> : <FaEyeSlash />}</span>
                    </div>
                    {errors.password && <div className="error-text"><FaExclamationCircle /><span>{errors.password}</span></div>}
                </div>
                <div className="form-group">
                    <label htmlFor="address">Alamat</label>
                    <input type="text" name="address" value={formData.address} onChange={handleChange} required className={errors.address ? 'input-error' : ''} />
                    {errors.address && <div className="error-text"><FaExclamationCircle /><span>{errors.address}</span></div>}
                </div>
                <div className="form-group">
                    <label htmlFor="phone_number">Nomor HP</label>
                    <input type="text" name="phone_number" value={formData.phone_number} onChange={handleChange} required className={errors.phone_number ? 'input-error' : ''} />
                    {errors.phone_number && <div className="error-text"><FaExclamationCircle /><span>{errors.phone_number}</span></div>}
                </div>

                <button type="submit" className="submit-button" disabled={isLoading}>{isLoading ? 'Mendaftar...' : 'Register'}</button>
                
                {/* --- DAN DIPINDAHKAN KE SINI --- */}
                <p className="form-footer-link">
                    Sudah punya akun? <Link to="/login">Login di sini</Link>
                </p>
            </form>
        </div>
    );
};

export default RegisterPage;